














import Vue, { PropType } from 'vue';
export type DataType = {
  style: any;
}
export default Vue.extend({
  name: 'GAuthTextarea',
  props: {
    value: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    rows: { type: Number as PropType<number>, required: true },
    error: { type: Boolean as PropType<boolean>, default: false },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    maxlength: { type: Number as PropType<number>, required: true },
  },
  watch: {
    innerValue(val: string) {
      if (val && val.length > this.maxlength) {
        this.innerValue = val.substr(0, this.maxlength);
      }
    },
  },
  computed: {
    innerValue: {
      get(): string {
        return this.value;
      },
      set(val: string): void {
        this.$emit('input', val);
      },
    },
  },
});
